import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';

export type TeamChipMenuData = Record<string, unknown>;

@Component({
  selector: 'la-team-chip-editable',
  templateUrl: './team-chip-editable.component.html',
  styleUrls: ['./team-chip-editable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatChipsModule, MatIconModule, MatButtonModule, MatMenuModule],
})
export class TeamChipEditableComponent {
  @Input() color?: string;
  @Input() removable = false;
  @Input() readonly = false;
  @Input() menu?: MatMenu | null;
  @Input() menuData?: TeamChipMenuData | null;

  @Output() remove = new EventEmitter<void>();
}
